import { Node, mergeAttributes } from "@tiptap/core";

export const FileExtension = Node.create({
  name: "file",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      src: {},
      filename: {},
      filetype: {},
      uploadedAt: {},
    };
  },

  parseHTML() {
    return [
      {
        //tag: "div[data-type='file-block']",
         tag: "div.tiptap-file",
        getAttrs: (dom) => {
          if (!(dom instanceof HTMLElement)) return false;
          return {
            src: dom.dataset.src,
            filename: dom.dataset.filename,
            filetype: dom.dataset.filetype,
            uploadedAt: dom.dataset.uploadedAt,
          };
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const { src, filename } = HTMLAttributes;

    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-type": "file-block",
        "data-src": src,
        "data-filename": filename,
        style: `
          margin: 8px 8px 8px 0;
          padding: 8px;
          border-radius: 16px;
          display: inline-block;
          text-align: center;
          width: 200px;
          height: 150px;
          border: 1px solid #ccc;
          overflow: hidden;
          cursor: pointer;
        `,
        onclick: `window.open('${src}', '_blank')`,
      }),
      [
        "div",
        {
          style: `
            width: 100%;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f5f5f5;
            color: #888;
            font-size: 12px;
          `,
        },
        "📄 PDF Preview",
      ],
      [
        "div",
        {
          style: `
            font-weight: 500;
            font-size: 13px;
            margin-top: 4px;
            padding: 0 8px;
            word-break: break-word;
          `,
        },
        filename || "Untitled",
      ],
    ];
  },
});


// import { Node, mergeAttributes } from "@tiptap/core";

// export const FileExtension = Node.create({
//   name: "file",
//   group: "block",
//   atom: true,

//   addAttributes() {
//     return {
//       src: {},
//       filename: {},
//       filetype: {},
//       uploadedAt: {},
//     };
//   },

//   parseHTML() {
//     return [{ tag: "div[data-type='file-block']" }];
//   },

//   renderHTML({ HTMLAttributes }) {
//     return [
//       "div",
//       mergeAttributes(HTMLAttributes, { "data-type": "file-block" }),
//       [
//         "div",
//         {
//           style:
//             "display: flex; flex-direction: column; border: 1px solid #ccc; border-radius: 6px; padding: 10px; background: #fafafa; max-width: 300px;",
//         },
//         [
//           "div",
//           { style: "display: flex; align-items: center; gap: 10px;" },
//           [
//             "div",
//             {
//               style:
//                 "width: 32px; height: 32px; background: #e0e0e0; border-radius: 4px; display: flex; align-items: center; justify-content: center; font-size: 0.8rem;",
//             },
//             HTMLAttributes.filetype?.toUpperCase() || "FILE",
//           ],
//           ["strong", {}, HTMLAttributes.filename || "Untitled"],
//         ],
//         [
//           "a",
//           {
//             href: HTMLAttributes.src,
//             target: "_blank",
//             rel: "noopener noreferrer",
//             style: "margin-top: 8px; font-size: 0.85rem; color: #1976d2;",
//           },
//           "Download",
//         ],
//       ],
//     ];
//   },
// });
